import React from 'react';
import ReactPaginate from 'react-paginate';
import styled from 'styled-components';

interface PaginateProps {
  pageCount: number;
  forcePage: number;
  handlePageClick: (selected: any) => void;
}

const Pagination = ({ pageCount, handlePageClick, forcePage }: PaginateProps) => {
  return (
    <Style>
      <ReactPaginate
        nextLabel={false}
        previousLabel={false}
        onPageChange={handlePageClick}
        pageRangeDisplayed={4}
        marginPagesDisplayed={0}
        pageCount={pageCount}
        pageClassName="page-item"
        pageLinkClassName="page-link"
        previousClassName="page-item"
        previousLinkClassName="page-link"
        nextClassName="page-item"
        nextLinkClassName="page-link"
        breakClassName="break-page-item"
        breakLinkClassName="page-link"
        containerClassName="pagination"
        activeClassName="active"
        disableInitialCallback
        renderOnZeroPageCount={null}
        forcePage={forcePage}
      />
    </Style>
  );
};

export default Pagination;

const Style = styled.div`
  ul,
  li,
  ol,
  a {
    list-style: none;
    cursor: pointer;
  }
  ul {
    width: 60%;
    margin: 0 auto;
    margin-top: 70px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  li {
    margin: 0 12px;

    a {
      border: 1px solid #000;
      border-radius: 6px;
      padding: 10px 15px;
      font-size: 16px;
      font-weight: 700;
      width: 100%;
    }
    .page-link {
      border: none;
    }
  }
  .active {
    margin: 0 12px;

    a {
      background: #000;
      color: #fff;
    }
  }
  .break-page-item {
    display: none;
  }

  @media (max-width: 900px) {
    ul {
      padding: 0;
      margin-top: 14px;
      margin-bottom: 16px;
    }
    li {
      margin: 0 6px;
      a {
        padding: 6px 12px;
      }
    }
    .active {
      margin: 0 6px;

      a {
        background: #000;
        color: #fff;
      }
    }
  }
`;
